import { debounce } from "lodash";

export const formatCodeNumber = (value: string): string => {
  if (!value) {
    return "";
  }

  return value.replace(/[^\d-]/g, "");
  // Chỉ giữ lại số
  const numbers = (value || "").replace(/\D/g, "");

  // Áp dụng format tùy theo độ dài
  if (numbers.length <= 3) {
    return numbers;
  } else if (numbers.length <= 7) {
    return `${numbers.slice(0, 3)}-${numbers.slice(3)}`;
  } else if (numbers.length <= 11) {
    return `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(7)}`;
  }
  // Giới hạn tối đa 11 số
  return `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(
    7,
    11
  )}`;
};

export const debouncedFormatPhone = debounce(formatCodeNumber, 100);

export const toHalfWidth = (str: string) => {
  return str.replace(
    /[０-９－．，　]/g,
    (s) => String.fromCharCode(s?.charCodeAt(0) - 0xfee0) || ""
  );
};
